import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import styles from './style';

class TitlePart extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { titlepart } = this.props;
    let note = '';
    if (titlepart.note) {
      note = ` (${titlepart.note})`;
    }
    return (
      <div style={styles.tirtle}>{titlepart.title}{note}</div>
    );
  }
}

TitlePart.propTypes = {
  titlepart: PropTypes.shape()
};

TitlePart.defaultProps = {
  style: {},
  titlepart: {}
};

export default TitlePart;



// WEBPACK FOOTER //
// ./src/Parts/TitlePart/index.js